import React from 'react';
import styled from 'styled-components';
import { safeGet } from '../../../../../core/util/object';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { formatPhone } from '../../../../../core/util/string';

const Phone = styled.a.withConfig({ componentId: 'sc-4jdo5q-0' })`
  color: ${(props) => props.color};
  cursor: pointer;
  white-space: nowrap;
`;

type Props = {
  insuranceCarrierName?: string;
  insuranceCarrierDisplayProperties?: any;
  insurerCode?: string;
  insurerType?: string;
  insurerPhone?: string;
  trackingCode?: string;
  className?: string;
};

const InsurerPhone = (props: Props) => {
  const {
    insuranceCarrierDisplayProperties,
    insurerPhone,
    className,
    trackingCode,
    insurerType,
    insurerCode,
    insuranceCarrierName,
  } = props;

  const trackClickCallCarrier = () => {
    analyticsTrackEvent(trackingCode, {
      insuranceCarrierName,
      insurerCode,
      insurerType,
    });
  };

  return (
    <Phone
      className={className}
      color={safeGet(insuranceCarrierDisplayProperties)('color')}
      href={`tel:${insurerPhone}`}
      onClick={trackClickCallCarrier}
    >
      {formatPhone(insurerPhone)}
    </Phone>
  );
};

export default InsurerPhone;
